import * as React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
//import Typography from '@mui/material/Typography';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandMore from '../components/ExpandMore'

const SimpleAccordion = ({ items }) => {

    return (
        <div>
            {items.map((item, index) => (
                <Accordion key={index}>
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls={`panel${index}a-content`}
                        id={`panel${index}a-header`}
                    >
                        <div>{item.title}</div>
                    </AccordionSummary>
                    <AccordionDetails className="custom-content">
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                        </div>
                        {item.team && item.team.length > 0 && (
                            <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 xl:gap-4">
                                {item.team.map((member, memberIndex) => (
                                    <div className="lg:basis-4/12 bg-gandalf-400 p-6 lg:p-8 rounded" key={memberIndex}>
                                        <h3 className="text-h4">{member.name}</h3>
                                        <p className="mb-4 text-aragon-900/[0.4] text-[14px]">{member.profession}</p>
                                        <p>
                                            <a href={`tel:${member.phone}`}>{member.phone}</a><br/>
                                            <a href={`mailto:${member.email}`}>{member.email}</a>
                                        </p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    );
};

export default SimpleAccordion;